<script>
    import { links } from 'svelte-routing';
    import { auth, authState } from '~/firebase';
    import categories from '~/categories';

    function signOut() {
        auth.signOut();
    }

    function scrollDown() {
        setTimeout(() => {
            document
                .getElementById('main')
                .scrollIntoView();
        }, 200);
    }
</script>

<style lang="scss">
    .banner {
        background-color: $banner;
        border-bottom: dashed 1px $divider;
    }
    
    .tagline {
        text-align: center;
    }

    nav {
        padding-top: 2rem;
        ul {
            padding: 0;
            margin: 0;
            list-style: none;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            
            li {
                padding: 0.5rem 1rem;
                text-transform: lowercase;

                a:visited:not(:hover):not(:active) {
                    color: $link;
                }
            }

            @media (max-width: $mobile-width) {
                flex-direction: column;
                align-items: stretch;
                li {
                    a {
                        text-align: center;
                        padding: 0.5rem;
                        display: block;
                    }
                }
            }
        }
    }

    @media (max-width: $mobile-width) {
        .banner {
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
    }

    .caret {
        animation: caretAnimation 0.5s infinite alternate;
    }

    @keyframes caretAnimation{
        0% {
            color: $subtle;
        }
        45% {
            color: $subtle;
        }
        55% {
            color: transparent;
        }
        100% {
            color: transparent;
        }
    }

    .sign-out {
        position: absolute;
        top: 2rem;
        right: 2rem;
    }
</style>

<header class="banner">
    <div class="wrapper">
        <h1><a href="/">Nan Dake</a><span class="subtle">><span class="caret">_</span></span></h1>
        <div class="tagline">A website featuring mostly useless content.</div>
        <nav>
            <ul use:links>
                <li><a href="/" on:click={scrollDown}>Blog</a></li>
                <li><a href="/about" on:click={scrollDown}>About</a></li>
                <li><a href="/ask" on:click={scrollDown}>Ask</a></li>
                <li><a href="https://www.youtube.com/channel/UCdWS3wEIziJuBTMSGyZcbTQ" noroute>YouTube</a></li>
                {#each categories as category}
                    {#if category.visible !== false}
                        <li><a href="/{category.name}" on:click={scrollDown}>{category.name}</a></li>
                    {/if}
                {/each}
            </ul>
        </nav>
    </div>
</header>

{#if $authState}
    <div class="sign-out">
        <a href="javascript:void(0);" on:click={signOut}>Sign out</a>
    </div>
{/if}
